if (!customElements.get("custom-media-gallery")) {
  customElements.define(
    "custom-media-gallery",
    class CustomMediaGallery extends HTMLElement {
      constructor() {
        super();
        console.debug("Custom gallery load");

        this.$slider = $(this.querySelector("[data-product-slick-slider]"));
        this.$slides = this.$slider.find("[data-product-slick-slider-silde]");

        this.$slider.slick({
          arrows: false,
          dots: this.$slides.length >= 2,
        });

        this.$slides.each((_, slide) => {
          const $slide = $(slide);

          const slideMouseState = {
            clicked: false,
            mouseDownPosition: { x: 0, y: 0 },
            mousePosition: { x: 0, y: 0 },
          };

          const distance = ({ x: x1, y: y1 }, { x: x2, y: y2 }) => {
            return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
          };

          $slide.on("mousedown", (event) => {
            slideMouseState.mouseDownPosition.x = event.pageX;
            slideMouseState.mouseDownPosition.y = event.pageY;
          });

          $slide.on("mousemove", (event) => {
            slideMouseState.mousePosition.x = event.pageX;
            slideMouseState.mousePosition.y = event.pageY;
          });

          $slide.on("click", (event) => {
            slideMouseState.clicked = true;

            slideMouseState.mousePosition.x = event.pageX;
            slideMouseState.mousePosition.y = event.pageY;

            const clickMousePosition = {
              x: slideMouseState.mousePosition.x,
              y: slideMouseState.mousePosition.y,
            };
            console.log("Clicked on slide", { $slide });

            setTimeout(() => {
              const clicked = slideMouseState.clicked;
              const translatedDistance = distance(
                clickMousePosition,
                slideMouseState.mouseDownPosition
              );
              if (clicked && translatedDistance < 10) {
                this.onSlideClick();

                slideMouseState.clicked = false;
                console.debug("Slide clicked", { clicked, translatedDistance });
              } else {
                console.debug("Slide click ignored", {
                  clicked,
                  translatedDistance,
                });
              }
            }, 100);
          });
        });
      }

      onSlideClick() {
        this.$slider.slick("slickNext");
      }

      setActiveMedia(mediaId, prepend) {
        const selector = `[data-media-id="${mediaId}"]`;
        console.log("Set active media", { mediaId, prepend });
        const slide = this.querySelector(selector);
        if (slide) {
          const slickIndex = slide.dataset.slickIndex;
          console.debug("Set active media", { slickIndex });
          this.$slider.slick("slickGoTo", slickIndex, true);
        } else {
          console.log("Image not available");
        }
      }
    }
  );
}

if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (this.dataset.desktopLayout !== "stacked" && this.mql.matches)
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
